import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { useTranslation } from 'react-i18next';
import * as ROUTES from 'helpers/route-helper';


export default function Footer() {

  const date = new Date();
  const getYear = date.getFullYear();
  const lang = localStorage.getItem("lang");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleContent = (obj) => {
    const slugify = str =>
      str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');

    let newSlug = slugify(obj)
    navigate('/' + newSlug)

  }

   /**
     * Used for render the UI of footer in all pages
     */

  return (
    <>
      <section className="footer-main position-relative">
        <Container className="p-0">
          <div className="social_icon_bar border-bottom">
            <div className="social_bar">
              <ul>
                <li>
                  <a href="https://www.facebook.com/getsoor" target="_blank" title={t('facebook')}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"
                        fill="#191919"
                      />
                    </svg>
                  </a>
                </li>
               
                <li>
                  <a href="https://www.instagram.com/getsoor" target="_blank" title={t('instagram')}>
                    <svg xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                        viewBox="0 0 50 50"
                        
                        >
    <path  d="M 16 3 C 8.83 3 3 8.83 3 16 L 3 34 C 3 41.17 8.83 47 16 47 L 34 47 C 41.17 47 47 41.17 47 34 L 47 16 C 47 8.83 41.17 3 34 3 L 16 3 z M 37 11 C 38.1 11 39 11.9 39 13 C 39 14.1 38.1 15 37 15 C 35.9 15 35 14.1 35 13 C 35 11.9 35.9 11 37 11 z M 25 14 C 31.07 14 36 18.93 36 25 C 36 31.07 31.07 36 25 36 C 18.93 36 14 31.07 14 25 C 14 18.93 18.93 14 25 14 z M 25 16 C 20.04 16 16 20.04 16 25 C 16 29.96 20.04 34 25 34 C 29.96 34 34 29.96 34 25 C 34 20.04 29.96 16 25 16 z"></path>
</svg>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/getsoor?s=21&t=LFwF4nV_t6TWUeyl72sXQw" target="_blank" title={t('twitter')}>
                  
<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="24px" height="24px"><path d="M 6.9199219 6 L 21.136719 26.726562 L 6.2285156 44 L 9.40625 44 L 22.544922 28.777344 L 32.986328 44 L 43 44 L 28.123047 22.3125 L 42.203125 6 L 39.027344 6 L 26.716797 20.261719 L 16.933594 6 L 6.9199219 6 z"/></svg>
                  </a>
                </li>
              </ul>
            </div>

            <div className="policy_side">
              <ul>
                <li><div className="dot"></div></li>
                <li>
                  <a href={ process.env.REACT_APP_WEBSITE_URL + ROUTES.TERMS_CONDITIONS} target="_blank"> 
                  {t('terms_conditions')}
                  </a>
                  {/* <Link to={  ROUTES.TERMS_CONDITIONS} target="_blank">{t('terms_conditions')}</Link> */}

                </li>
                <li><div className="dot"></div></li>


                <li>
                  <a href={process.env.REACT_APP_WEBSITE_URL + ROUTES.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">

                    {t('privacy_policy')}
                  </a>
                  {/* <Link to={ ROUTES.PRIVACY_POLICY} target="_blank">{t('privacy_policy')}</Link> */}


                </li>
              </ul>
            </div>
          </div>
          <div className="footer-copyright text-center py-2">
            <p>© 2023-{getYear} {t('right_reserved')}
            </p>
          </div>
        </Container>
      </section>
    </>
  );
}
